if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        // itg js 
        if(this.classList.contains('build-box-product')){
            let secArr = this.cart.getSectionsToRender().map((section) => section.id);
            secArr.push('build-box-cart-data');
            formData.append('sections',secArr);
            formData.append('properties[_buildbox]',true)
        }
        if(this.classList.contains('swap-product-form') || this.querySelector('.swap-quick-add__submit')){
            formData.append('properties[_swapbox]',true)
            swapBoxAdd(this,formData);
            return false;
        }
        // itg js end
        
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                    // itg js
                      updateBuildBox(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              if(this.classList.contains('swap-product-form')){
                swapBoxAdd(this,response);
              }else{
                this.cart.renderContents(response);
              }
              // itg js
                updateBuildBox(response);
                checkPacking();
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            // itg js
            if(!this.classList.contains('swap-product-form')){
              loadOff(this);
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}


// loading off
function loadOff(pForm) {
  pForm.submitButton.classList.remove('loading');
  if (pForm.cart && pForm.cart.classList.contains('is-empty')) pForm.cart.classList.remove('is-empty');
  if (!pForm.error) pForm.submitButton.removeAttribute('aria-disabled');
  pForm.querySelector('.loading__spinner').classList.add('hidden');
}


// swap box addToCart
async function swapBoxAdd(pForm,formData) {
  let swapBoxData = await createSwapData(pForm,formData);
  if(swapBoxData.items.length > 0){
      fetch("/cart/add.js", {
          method: "POST",
          headers: {
              "Content-Type": "application/json"
          },
          body: JSON.stringify(swapBoxData)
      }).then(data=>data.json()).then(data=>{
        pForm.cart.renderContents(data);
      }).catch(error=>{
        console.error("Error adding bundle to cart:", error);
      }).finally(() => {
          loadOff(pForm);
      });
  }
}

function createSwapData(pForm,formData){
  const d = new Date();
  let time = d.getTime();
  formData = Array.from(formData)
  let mainSwapBox = getMainSwap(formData,time);
  let itemQty = [],itemId = [],itemData = [];
  document.querySelectorAll('.inside-plus-product-details').forEach((ele)=>{
    itemId.push(ele.dataset.id);
    itemQty.push(ele.dataset.qty);
  });
  // document.querySelectorAll('.inside-product-details').forEach((ele)=>{
  //   let inId = ele.querySelector('.swap-item-input').dataset.id;
  //   itemId.push(inId);
  //   itemQty.push(1);
  // });
  // if(pForm.querySelector('.quick-add__submit')){
  //   pForm.querySelectorAll('.swap-item-input').forEach((ele)=>{
  //     let inId = ele.dataset.id;
  //     itemId.push(inId);
  //     itemQty.push(1);
  //   });
  // }
  
  for (var i in itemId)
  itemData.push({id: itemId[i],quantity: itemQty[i],properties:{ _swapBoxId: time}});
  itemData.push(mainSwapBox);
  return {
    items:itemData,
    sections:pForm.cart.getSectionsToRender().map((section) => section.id),
    sections_url:window.location.pathname
  }
}


function getMainSwap(formData,time) {
    let mainId = '',
    mainQty = '',
    mainProp = {};
   mainProp['_mainSwapBoxId'] = time;
  for (let i = 0; i < formData.length; i++) {
    if(formData[i][0] == 'id'){
      mainId = formData[i][1];
    }
    if(formData[i][0] == 'quantity'){
      mainQty = formData[i][1];
    }
    if(formData[i][0].includes('properties')){
      let porpFirst = formData[i][0].replace('properties[','').replace(']','');
      mainProp[porpFirst] = formData[i][1];
    }
  }
  return {
    id: mainId,
    quantity: mainQty,
    properties:mainProp
  }
}
